import { COLORS } from '../../config/designSystem/Colors';
import { SPACING } from '../../config/designSystem/Spacing';
import { View } from 'react-native';

type ProgressBarPathProp = {
    readPercentage: number;
    width: number;
}

export const HEIGHT_PROGRESS_BAR = SPACING['sp-8'];

export const ProgressBarPath = ({readPercentage, width}: ProgressBarPathProp) => {
  const PADDING = 1;

  return(<View
    style={{
      height: HEIGHT_PROGRESS_BAR,
      borderRadius: SPACING['sp-16'],
      padding: PADDING,
      width,
      backgroundColor: COLORS.surface.primary,
      zIndex:2
    }}
  >
    <View
      style={{
        flex:1,
        width: 1 * width * Math.max(2, readPercentage) / 100,
        borderRadius: SPACING['sp-16'],
        backgroundColor: COLORS.state.info.primary,
        zIndex:3
      }}
    />
  </View>);
};